import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import S3WriterForm from '../forms/s3-writer-form';
import { s3WriterValidationSchema } from '../schema/s3Writer.js';

export default function S3WriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Amazon S3 Writer Node Details',
        altText: 'Amazon S3 Writer Node',
        defaultLabel: 'S3 Writer Node',
      }}
    >
      <CommonNode FormComponent={S3WriterForm} schemaResolver={s3WriterValidationSchema} />
    </NodeProvider>
  );
}
